module.exports = file => () => import('@/views/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/store/modules/router/_import_production.js